import { useState } from 'react';
import { Button } from '../../../components/ui/button';
import { ConnectPanel } from '../../../components/connect/ConnectPanel';
import { StepScaffold } from '../StepScaffold';

/** Step 3 — connect a cloud account (required) to continue; a code base is
 * strongly recommended but optional (it unlocks exact, repo-grounded fixes, and
 * we upsell it on recommendations afterward). The body is the shared ConnectPanel
 * (also used by the add-domain modal); this wrapper supplies the onboarding chrome. */
export function ConnectStep({
  envId,
  onDone,
  onBack,
  eyebrow = 'Connect your cloud',
}: {
  envId: string;
  onDone: () => void;
  onBack?: () => void;
  eyebrow?: string;
}) {
  const [ready, setReady] = useState(false);

  return (
    <StepScaffold
      eyebrow={eyebrow}
      title="Connect a cloud account"
      lead="Lizrd reads your resources and spend to find savings. Start with one cloud — add the rest anytime. Linking a code base is optional, and turns each finding into the exact fix."
      safety="Read-only, least-privilege access. You approve the exact permissions, we never change your infrastructure, everything is encrypted and isolated to your workspace, and you can revoke access at any time."
      onBack={onBack}
      footer={
        <Button type="button" disabled={!ready} onClick={onDone}>
          {ready ? 'Continue' : 'Connect a cloud to continue'}
        </Button>
      }
    >
      <ConnectPanel envId={envId} onReadyChange={setReady} />
    </StepScaffold>
  );
}
